export const artikel4 = `
Shalat jenazah adalah shalat yang dilakukan  untuk mendo’akan  seorang muslim atau muslimah yang telah meninggal dunia; baik dia laki-laki maupun perempuan; orang dewasa maupun anak-anak. Di arab Saudi sendiri terutama di Makkah dan Madinah hampir setiap selesai shalat fardlu melakukan 2 rakaat shalat ini, hal ini dilakukan oleh pemerintah Saudi agar seluruh jamaah yang berada di Masjidil Haram dan juga Masjid Nabawi bisa mendoakan sesama muslim yang telah wafat dari seluruh penjuru dunia.

Adapun, shalat jenazah hukumnya wajib kifayah, yakni kewajiban yang pelaksanaannya dapat tercukupi manakala telah ditunaikan oleh sebagian kaum muslimin. Namun jika tidak ada yang melaksanakannya, maka seluruh kaum muslimin berdosa karenanya.

<strong>Keutamaan Shalat Jenazah</strong>

Mengenai keutamaan shalat jenazah, diterangkan di dalam beberapa hadits berikut:

Dari Abu Hurairah, ia berkata bahwa Rasulullah SAW  bersabda,

مَنْ شَهِدَ الْجَنَازَةَ حَتَّى يُصَلِّىَ عَلَيْهَا فَلَهُ قِيرَاطٌ ، وَمَنْ شَهِدَ حَتَّى تُدْفَنَ كَانَ لَهُ قِيرَاطَانِ  . قِيلَ وَمَا الْقِيرَاطَانِ قَالَ  مِثْلُ الْجَبَلَيْنِ الْعَظِيمَيْنِ

 “Barangsiapa yang menyaksikan jenazah sampai ia menyolatkannya, maka baginya satu qiroth. Lalu barangsiapa yang menyaksikan jenazah hingga dimakamkan, maka baginya dua qiroth.” Ada yang bertanya, “Apa yang dimaksud dua qiroth?” Rasulullah shallallahu ‘alaihi wa sallam lantas menjawab, “Dua qiroth itu semisal dua gunung yang besar.” (HR. Bukhari  dan Muslim )

Hadits yang bersumber dari ‘Aisyah RA, ia berkata “ Bahwa Nabi SAW telah bersabda”:

مَا مِنْ مَيِّتٍ يُصَلِّى عَلَيْهِ أُمَّةٌ مِنَ الْمُسْلِمِينَ يَبْلُغُونَ مِائَةً كُلُّهُمْ يَشْفَعُونَ لَهُ إِلاَّ شُفِّعُوا فِيه

ِ“Tidaklah seorang mayit dishalatkan (dengan shalat jenazah) oleh sekelompok kaum muslimin yang mencapai 100 orang, lalu semuanya memberi syafa’at  (mendoakan kebaikan untuknya), maka syafa’at (do’a mereka) akan diperkenankan.” (HR. Muslim)

<strong>Syarat-syarat Shalat Janazah</strong>

Shalat jenazah sah dilakukan jika terpenuhi syarat-syarat sebagai berikut:

- Seseorang yang melaksanakan shalat jenazah harus memenuhi syarat-syarat sahnya seperti yang terdapat pada shalat yang lain, yakni  ia harus bersih dari hadats dan najis, menutup aurat dan menghadap kiblat.
- Shalat jenazah harus didirikan setelah jenazah dimandikan dan dikafani.
- Jenazah harus diletakkan di sebelah kiblat orang yang menyalatkannya.

<strong>Tata Cara Shalat Jenazah</strong>

Untuk syarat sama seperti sholat pada umumnya harus suci dari hadast besar dan juga hadast kecil, yang membedakan niat dan pelaksanaan shalatnya karna shalat ini tidak memiliki rukuk dan sujud di dalamnya.

Rukun shalat jenazah :

<strong>1. Niat</strong>

أُصَلَّى عَلَى هَذِهِ الْمَيِّتَةِ أَرْبَعَ تَكْبِيرَات فَرْضُ كِفَايَةِ إماما/مَأْمُوماً لله تَعَالَى

 Latin: Ushalli ‘ala hadzal mayyiti arba’a takbiratin fardhu kifayati (imaman/ma’muman) lillahi Ta’ala. Allahu akbar.

 Artinya: “Saya berniat salat untuk mayat (Laki-laki) ini empat takbir karena menjalankan fardhu kifayah sebagai (imam/makmum) karena Allah Ta’ala. Allah Mahabesar.”

 <strong>2. Berdiri bagi yang mampu</strong>

 <strong>3. Takbir 4X</strong>

 <strong>4. Membaca surat Al-fatihah pada takbir pertama</strong>

 <strong>5.Membaca shalawat pada nabi Muhammad saw setelah takbir ke 2</strong>, bacaan minimal shalawat yang mencukupi dalam sahnya salat jenazah sebagai berikut:

 اَللّٰهُمَّ صَلِّ عَلَى سَيِّدِنَا مُحَمَّدٍ

 Latin: Allâhumma shalli ‘alâ sayyidinâ Muhammad.

 Artinya: “Ya Allah, limpahkanlah rahmat kepada Nabi Muhammad.”

 <strong>6. Berdoa kepada untuk kebaikan jenazah setelah takbir ke 3</strong>

 اللَّهُمَّ اغْفِرْ لَهُ وَارْحَمْهُ وَعَافِهِ وَاعْفُ عَنْهُ وَأَكْرِمْ نُزُلَهُ وَوَسَعْ مَدْخَلَهُ، وَاغْسِلْهُ بِمَاءٍ وَثَلْجِ وَبَرَدٍ وَنَقِّهِ مِنَ الْخَطَايَا كَمَا يُنَقَّى الثَّوْبُ الْأَبْيَضُ مِنَ الدَّنَسِ، وَأَبْدِلْهُ دَارًا خَيْرًا مِنْ دَارِهِ، وَأَهْلاً خَيْرًا مِنْ أَهْلِهِ، وَزَوْجًا خَيْرًا مِنْ زَوْجِهِ، وَفِهِ فِتْنَةَ الْقَبْرِ وَعَذَابَ النَّارِ

 Latin: Allahummaghfirlahu warhamhu wa’afihi wa’fu ‘anhu wa akrim nuzulahu wa wassi’ madkhalahu wa aghsilhu bimaa-in wa tsaljin walbaradin wa naqqihi minal khathaayaa kamaa yunaqqats tsaubul abyadhu minaddanasi wa abdilhu daaran khairan min daarihi wa ahlan khairon min ahlihi wa zaujan khairan min zaujihi wa qihi fitnatal qabri wa ‘adzaa ban naar.

 Artinya: “Ya Allah, ampunilah dia, kasihanilah dia, berilah keselamatan dan ampunilah dosanya, muliakanlah tempat tinggalnya dan lapangkanlah tempat keluarnya, sucikanlah ia dengan air, es, dan embun, serta bersihkanlah ia dari segala dosa dan kesalahan sebagaimana Engkau telah membersihkan baju putih dari kotoran. Berilah ganti baginya tempat yang lebih baik dari tempatnya yang terdahulu, keluarga yang lebih baik dari keluarga semula, pasangan yang lebih baik dari pasangan semula, serta lindungilah ia dari fitnah kubur dan siksa neraka.” (HR Muslim dari Auf bin Malik).

 Catatan: untuk doa yang dibaca هُ (hu) diganti dengan هَا (ha) apabila jenazah perempuan

 <strong>7. doa untuk kebaikan kita masing masing setelah takbir ke 4</strong>

 اللَّهُمَّ لَا تَحْرِمْنَا أَجْرَهُ وَلَا تَفْتِنَا بَعْدَهُ، وَاغْفِرْ لَنَا وَلَهُ

Latin: Allahumma laa tahrimna ajrohu wa laa taftinna ba’dahu waghfir lana wa lahu.

Artinya: “Ya Allah, jangan haramkan kami dari pahalanya dan jangan beri fitnah (cobaan) bagi kami sepeninggalnya. Ampunilah kami dan ampunilah dia.”

Catatan: untuk doa yang dibaca هُ (hu) diganti dengan هَا (ha) apabila jenazah perempuan.

<strong>8. Salam</strong>

اَلسَّلَامُ عَلَيْكُمْ وَرَحْمَةُ اللهِ وَبَرَكَا تُهُ

 Latin: Assalamualaikum Warahmatullahi Wabarakatuh

 Artinya: “Semoga keselamatan tercurah untukmu serta pengampunan dan berkah dari Allah SWT.”

Itulah penjelesan tentang niat salat jenazah lengkap dengan ketentuan dan cara melaksanakannya. Semoga bermanfaat dan dapat diamalkan ketika ada umat Islam yang meninggal dunia.
`;
